import { ProductPrice } from '~/Api/Product';

export default class ProductHistoryPriceChange {
	previous: ProductPrice | null;

	current: ProductPrice | null;

	constructor(previous: ProductPrice | null, current: ProductPrice | null) {
		this.previous = previous;
		this.current = current;
	}
}
